import React from 'react';

export const MCP_AUTHORIZE_PATH = '/sso/authorize';
export const MCP_TERMS_URL = 'https://www.theinformation.com/terms#mcp-terms';

export const isMcpLogin = (returningUrl: string | null): boolean =>
  !!returningUrl && returningUrl.startsWith(MCP_AUTHORIZE_PATH);

const McpTermsNotice: React.FC = () => (
  <div className="mt-16 text-center text-[15px]">
    By authorizing the MCP, you agree to our{' '}
    <a href={MCP_TERMS_URL} className="text-[#F32A52]" target="_blank" rel="noopener noreferrer">
      MCP Terms
    </a>
  </div>
);

export default McpTermsNotice;
